import React from 'react';
import { connect } from 'react-redux';
import ScheduleTabComponent from './ScheduleTabComponent';

import { scheduleCalendarOperations } from 'pages/ScheduleCalendar/duck';

const mapStateToProps = ({
  appReducer,
  locationReducer,
  scheduleCalendarReducer,
}) => {
  return {
    locationSettings: appReducer.location.settings,
    allUsers: scheduleCalendarReducer.allUsers.users,
    locationData: locationReducer.location_data,
  };
};

const mapDispatchToProps = (dispatch) => {

  const addDraftShiftToUserDispatch = (owner_id, startDateTime, endDateTime, jobTitle, locationId) => {
    dispatch(scheduleCalendarOperations.addDraftShiftToUserOnDateOperation(owner_id, startDateTime, endDateTime, jobTitle, locationId));
  };

  const deleteShiftsDispatch = (shift, locationId) => {
    dispatch(scheduleCalendarOperations.deleteShiftOperation(shift.id, locationId));
  }

  const editSingleShiftDispatch = (shiftId, updates) => {
    dispatch(scheduleCalendarOperations.editSingleShiftOperation(shiftId, updates));
  }

  return {
    addDraftShiftToUserDispatch,
    deleteShiftsDispatch,
    editSingleShiftDispatch,
  };
};


const ScheduleTabContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props) => {
  const {
    locationSettings,
    allUsers,
    locationData,
    addDraftShiftToUserDispatch,
    deleteShiftsDispatch,
    editSingleShiftDispatch,
    match,
  } = props;

  return <ScheduleTabComponent
    locationSettings={locationSettings}
    allUsers={allUsers}
    locationData={locationData}
    match={match}
    addDraftShiftToUserDispatch={addDraftShiftToUserDispatch}
    deleteShiftsDispatch={deleteShiftsDispatch}
    editSingleShiftDispatch={editSingleShiftDispatch}
  />
});

export default ScheduleTabContainer;